/**
 * 中文（简体）语言包 - 汇总
 * 公共 + 各模块合并导出
 */
import common from './common/zh-CN'
import route from './modules/route/zh-CN'
import callCenter from './modules/callCenter/zh-CN'
import agentProvider from './modules/agentProvider/zh-CN'
import purchasing from './modules/purchasing/zh-CN'
import subscriptionCard from './modules/subscriptionCard/zh-CN'
import equipment from './modules/equipment/zh-CN'
import finance from './modules/finance/zh-CN'
import operateManage from './modules/operateManage/zh-CN'
import operationCenter from './modules/operationCenter/zh-CN'
import showCard from './modules/showCard/zh-CN'
import serviceCenter from './modules/serviceCenter/zh-CN'
import salesCenter from './modules/salesCenter/zh-CN'
import dataCenter from './modules/dataCenter/zh-CN'
import cockpit from './modules/cockpit/zh-CN'
import angentManage from './modules/angentManage/zh-CN'

export default {
  ...common,
  ...route,
  ...callCenter,
  ...agentProvider,
  ...purchasing,
  ...subscriptionCard,
  ...equipment,
  ...finance,
  ...operateManage,
  // Provide namespace access for keys used as `$t('operateManage.xxx')`
  // while keeping the original flat keys for backward compatibility.
  operateManage: operateManage,
  ...operationCenter,
  ...showCard,
  ...salesCenter,
  ...dataCenter,
  ...cockpit,
  ...angentManage,
  // 合并 serviceCenter：common 中的 serviceCenter 会被 modules/serviceCenter 覆盖，需要手动合并
  serviceCenter: {
    ...(common.serviceCenter || {}),
    ...(serviceCenter.serviceCenter || {})
  }
}
